import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, take } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RegistrationModel } from '../models/registration.model';

@Injectable({
  providedIn: 'root',
})
export class RegistrationRepository {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/api/product-requests`;

  public sendRegistration(data: RegistrationModel): Observable<RegistrationModel> {
    return this.http.post<RegistrationModel>(this.baseUrl, data, { withCredentials: true }).pipe(take(1));
  }
}
